import getStringDateAndHourFromDate from '../getStringDateAndHourFromDate'

export default function getDatesIntervalWithSubtractMinutes(minutes: number) {
  const calcDate = new Date().getTime() - minutes * 60 * 1000

  const today = new Date()
  const todayWithCalc = new Date(calcDate)

  const finalDate = getStringDateAndHourFromDate(today)
  const startDate = getStringDateAndHourFromDate(todayWithCalc)

  return {
    startDate: startDate.date,
    finalDate: finalDate.date,
    startHour: startDate.hour,
    finalHour: finalDate.hour,
  }
}
